import { IField } from "./AdminInterface";

export interface IGrid {
    id: string,   
    templateName: string | undefined,
    name: string,
    shortName: string | undefined,
    description: string,
    shortDescription: string | undefined,
    savedSearch: IField | undefined,
    cmQuery: string | undefined,
    container: IField |undefined,
    filters: string,
    fields: IGridField[],
    customSizing: boolean,
    selectedTheme: string,
    checkedOutTo: string | undefined, 
    lastUpdatedBy: string | undefined, 
    lastUpdatedDate: string | undefined,
    lastCachedDate: string | undefined,
    displayIcons: boolean | undefined,
    displayFileIcons: boolean | undefined,
    sortTableData: boolean | undefined,
    sortField: IField | undefined,
    sortOrder: string | undefined,
    displayElectronic: boolean | undefined,
    restrictSearch: boolean | undefined,
    displayLogo: boolean| undefined,
    recordsPerPage: number,
    downloadDocument: boolean | undefined,
    pdfRendition: boolean | undefined,
    viewPdfRendition: boolean | undefined,
    latestVersionOnly: boolean | undefined,
    latestFinalVersionOnly: boolean | undefined,
    disableTitle: boolean | undefined,
    disableSearch: boolean | undefined,
    viewDocument: boolean | undefined,
    editDocument: boolean | undefined,
    cacheTableData: boolean | undefined,
    wordWrap: boolean | undefined,
    defaultTableAction: number
};

export interface IGridField {
    name: string,
    propertyId: string,
    selected: boolean,
    searchClauseId: string,
    alias: string,
    colWidth:number,
    objectType: string,
    value: any,
    text?: string | null
};

export interface ITheme {
    id: string,
    name: string,
    headerColour: string,
    headerFontColour: string,
    tableBackgroundColour: string,
    tableFontColour: string,
    fontSize: string,
    fontFamily: string,
    tableBorder: string,
    customPath : string
}


export interface IGridDisplay {
    id: string,
    title: string,
    shortTitle: string,
    description: string,
    shortDescription: string,
    records: IRecord[],
    fields: IGridField[],
    customSizing: boolean,
    theme: ITheme,
    displayLogo: boolean
    disableTitle: boolean,
    disableSearchBar: boolean,
    viewDocDisplay: boolean,
    editDocDisplay: boolean,
    downloadDocument: boolean,
    renditionDisplay: boolean,
    viewRenditionDisplay: boolean,
    displayFileIcon: boolean,
    displayRecTypeIcon: boolean,
    wordWrap: boolean,
    totalRecords: number,
    timeLastCached: string
    totalPages: number,
    recordsPerPage: number
}

export interface IRecord {
    tableFields: ITableField[],
    uri: string,
    extension: string,
    icon: string,
    hasRendition: boolean,
    isEditable: boolean,
    isDownloadable: boolean,
    childRecords: IRecord[],
    childCount: number,
    defaultAction: ITableActions
}

export interface ITableField {
    fieldName: string,
    recordValue: string,
}

export enum ITableActions {
    View, 
    Edit, 
    Download,
    DownloadPDF, 
    DisplayPDF,
    None
}